// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"DTAInstallCertificate_bannerContainer__NAk6j"};